import React from "react";
import { Calendar, Clock, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import blogPosts from "../data/blogPosts";
import SocialMediaIcons from "./SocialMediaIcons";
import { gtmPush } from "../utils/gtm";

function Blog() {
  const handleBlogClick = (post) => {
    gtmPush("blog_card_click", {
      blog_title: post.title,
      blog_slug: post.slug,
      blog_category: post.category,
      destination: `/blog/${post.slug}`,
      element: "blog_card",
    });
  };

  const handleViewAllClick = () => {
    gtmPush("blog_listing_click", {
      element: "view_all_posts",
      destination: "/blog",
    });
  };
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Latest Blog Posts
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Read practical, uplifting insights on anxiety, resilience, burnout,
            relationships, confidence, and living with intention.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <article
              key={post.slug}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow"
            >
              <div className="relative">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-48 object-cover"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-purple-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {post.category}
                  </span>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-3">
                  <Calendar className="h-4 w-4 mr-2" />
                  <span>{new Date(post.date).toLocaleDateString()}</span>
                  <Clock className="h-4 w-4 ml-4 mr-2" />
                  <span>{post.readTime}</span>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight">
                  {post.title}
                </h3>

                <p className="text-gray-600 mb-4 leading-relaxed">
                  {post.excerpt}
                </p>

                <Link
                  to={`/blog/${post.slug}`}
                  onClick={() => handleBlogClick(post)}
                  className="inline-flex items-center text-purple-600 hover:text-purple-700 font-semibold"
                >
                  Learn More
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/blog"
            onClick={handleViewAllClick}
            className="bg-purple-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-purple-700 transition-colors inline-block"
          >
            View All Posts
          </Link>
        </div>
      </div>

      <SocialMediaIcons />
    </section>
  );
}

export default Blog;
